export const goBack = async (action, _datastore, { goBack }) => {
    goBack();
};
